export default "__VITE_ASSET__CwTCKFo3__"